const PENDING_BULK_REPORT_STORAGE_KEY = 'vestra/pending-bulk-report';
export const PENDING_BULK_REPORT_CHANGE_EVENT = 'vestra/pending-bulk-report-change';

export interface PendingBulkReport {
  id: number;
  registerId: number;
  startedAt: number;
}

export const getPendingBulkReport = (): PendingBulkReport | null => {
  const raw = sessionStorage.getItem(PENDING_BULK_REPORT_STORAGE_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw) as PendingBulkReport;
  } catch {
    sessionStorage.removeItem(PENDING_BULK_REPORT_STORAGE_KEY);
    return null;
  }
};

export const setPendingBulkReport = (report: PendingBulkReport) => {
  sessionStorage.setItem(PENDING_BULK_REPORT_STORAGE_KEY, JSON.stringify(report));
  window.dispatchEvent(new Event(PENDING_BULK_REPORT_CHANGE_EVENT));
};

export const clearPendingBulkReport = () => {
  sessionStorage.removeItem(PENDING_BULK_REPORT_STORAGE_KEY);
  window.dispatchEvent(new Event(PENDING_BULK_REPORT_CHANGE_EVENT));
};
